export const LIQUIDITY_VIEW = {
  LIQUIDITY_LIST: 'LIQUIDITY_LIST',
  REMOVE_LIQUIDITY: 'REMOVE_LIQUIDITY',
  ADD_LIQUIDITY: 'ADD_LIQUIDITY',
  CREATE_A_PAIR: 'CREATE_A_PAIR',
};
